import { Directive, ElementRef, OnInit, Optional } from '@angular/core';

import { NgControl } from '@angular/forms';

@Directive({
  // eslint-disable-next-line @angular-eslint/directive-selector
  selector: 'input, select, textarea',
  standalone: false,
})
export class NativeElementInjectorDirective implements OnInit {
  constructor(
    private el: ElementRef,
    @Optional() private control: NgControl,
  ) {}

  public ngOnInit(): void {
    if (!this.control || typeof this.control.control === 'undefined') {
      return;
    }

    (this.control.control as any).nativeElement = this.el.nativeElement;
  }
}
